import * as React from 'react';

import SvgIcon from 'material-ui/SvgIcon';

import { ColorWheelIcon } from './ColorWheelIcon';

interface ButtonTextColorIconProps {
    style?: React.CSSProperties;
}

export class ButtonTextColorIcon extends React.Component<ButtonTextColorIconProps, {}> {

    render() {
        const styles = this.getStyles();

        return (
            <div>
                <SvgIcon {...this.props}>
                    {/* tslint:disable:max-line-length */}
                    <path
                        transform="translate(-477 -74)"
                        d="M491.31,88.62L491,88h-6l-2,4h-2l6-14h2l3.819,8.911A8.031,8.031,0,0,0,491.31,88.62ZM488,80l-2,6h4Z"
                    />
                    {/* tslint:enable:max-line-length */}
                </SvgIcon>
                <ColorWheelIcon style={styles.colorWheel} />
            </div>
        );
    }

    private getStyles() {
        return {
            colorWheel: {
                width: 12,
                height: 12,
                verticalAlign: 'middle',
                marginLeft: -11,
                marginTop: -4
            }
        };
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/ButtonTextColorIcon.tsx
 **/